module.exports = __webpack_public_path__ + "img/top.2530dda9.jpg";